export class CustomField {
    customFieldValues:CustomFieldValue[] = [];
    static displayColumns:[string,string][];
    constructor(public name?:string,
                public value?:string,
                public display?:boolean,
                public displayIndex?:number,
                public uIEditable?:boolean,
                public dataType?:string,
                public handheldDisplay?:boolean,
                public handheldValue?:string,
                public handheldDisplayIndex?:number){
    }
    parseJson(json: any): void {
    }
    static parseJson(json:any) : CustomField {
        try {
            var cfn:CustomField =  new CustomField(json.name, json.value, json.display, parseInt(json.displayIndex), json.uIEditable,
                json.dataType, json.handheldDisplay, json.handheldValue, parseInt(json.handheldDisplayIndex));
            cfn.customFieldValues = [];
            for(var i=0; i<json.customFieldValues.length; i++){
                var cfnv = CustomFieldValue.parseJson(json.customFieldValues[i]);
                cfn.customFieldValues.push(cfnv);
            }
            return cfn;
        }
        catch(exc){
            return null;
        }
    }
}

export class CustomFieldValue{
    constructor(public customFieldName:string, public displayIndex:number, public value:string){
    }
    static parseJson(json:any):CustomFieldValue{
        var cfnv:CustomFieldValue = new CustomFieldValue(json.customFieldName, parseInt(json.displayIndex), json.value);
        return cfnv;
    }
}
